import '../CSS/ComingSoon.css'
import MainLayout from '../Layouts/MainLayout'
function ComigSoon(){
    return(
        <div>
            <MainLayout>
            <div className="comingmainWrapper">
            <h1 className='comingsoonHead'>Coming Soon....</h1>
            </div>
            </MainLayout>
        </div>
    )
}
export default ComigSoon;